<template>
    <div>
        <!--頁首-->
        <Header :header="header"></Header>
        <!--功能列表-->
        <Menulist :menulist="menulist"></Menulist>
        <!--功能列表_RWD-->
        <Menulist_RWD :menulist="menulist"></Menulist_RWD>
        <main class="main">
            <!--網站路徑(麵包屑)-->
            <Sitebar :sider="sider" ></Sitebar>
            <div class="incontall inconbox">
                <SideLeft_List :sideleft="sideleft"></SideLeft_List>
                <SideRight_Content :sideright="sideright" :className="menulist.place"></SideRight_Content>
            </div>
        </main>
        <!--頁尾-->
        <Footer :footer="footer"></Footer>
        <GoTop></GoTop>
    </div>
</template> 
<script>

import Header from '../../components/default_en/NavBar/Header.vue';
import Menulist from '../../components/default_en/NavBar/Menulist.vue';
import Menulist_RWD from '../../components/default_en/NavBar/Menulist_RWD.vue';
import Sitebar from '../../components/default_en/NavBar/Sitebar.vue';
import SideLeft_List from '../../components/default_en/Content/SideLeft_List.vue'
import SideRight_Content from '../../components/default_en/Content/SideRight_Content.vue';
import Footer from '../../components/default_en/NavBar/Footer.vue';
import GoTop from '../../components/default_en/Tool/GoTop.vue';

export default{
    components:{
        Header,        
        Menulist,
        Menulist_RWD,
        Sitebar,
        SideLeft_List,
        SideRight_Content,
        Footer,
        GoTop,
    },
    data(){
        return {
            //首頁
            header:{
                text1:"Department of Bio-Industry Communication and Development",
                text2:"About",
                text3:null,
            },
            //功能列表 &功能列表_RWD
            menulist:{
                place:"About",
            },
            //網站路徑(麵包屑)
            sider:{
                index:2,
                type:0,
                list:[{text:"About" ,url:"/About"}],
            },
            //左側資料(列表)
            sideleft:{
                title:"About",
                list:[],
            },
            sideright:{
                onlineDate:"",//請輸入上架日期
                onlinePlace: "",//上架單位
                title:"",//文章標題
                content:"",//目前尚未查詢到文章內容
                useTag:false,
            },
            //頁尾
            footer:{

            },
            //標題名稱
            title:"",
            //類別編號
            PJ_ID:"",
            //文章編號,
            type_id:"",
            //語言
            langurage:"2",
        }
    },
    computed:{

    },
    mounted(){
        //初始化
        this.init();
    },
    watch:{
        "type_id"(){
            //取得目前文章內容資訊
            this.getContent();
        },
    },
    methods:{
        //初始化
        init(){
            //讀取query參數
            if( this.$route.query){
                //目前頁面編號
                this.PJ_ID = this.$route.query.PJ_ID? this.$route.query.PJ_ID:"";
                //語言
                this.langurage = this.$route.query.lang? this.$route.query.lang: "2";
            }
            //取得網址的樣式名稱，並進行動態轉換，以減少讀取時間
            if(this.PJ_ID=="PJ20250403"){
                //切換至FAQ樣式，並匯入必要參數
                this._go("/EN/FAQ?PJ_ID="+this.PJ_ID+"&modal=4");
            }
            //取得目前頁面資訊
            this.getHeader();
        },
        //取得目前頁面資訊
        async getHeader(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"GetHeader_front",
                    about_type_SELECT:{
                        langurage :this.langurage,
                    },
                };
                //Token
                let resToken = await this.userRequest.post("bicd/Token");
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/AboutType",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if(json.Status){
                    let jsonData = JSON.parse(json.Data);
                    //匯入類別
                    let left_list = [];
                    jsonData.forEach((item ,index) => {
                        //若query沒有PJ_ID時，設定為第一個
                        if(this.PJ_ID =="" && index == 0){
                            this.PJ_ID = item.PJ_ID;
                            //特殊轉移
                            if(item.PJ_ID=="PJ20250403"){
                                this._go("/EN/FAQ?PJ_ID="+item.PJ_ID+"&modal=4");
                            }
                        }
                        let list_item = {text:item.etitle, url:"?PJ_ID="+item.PJ_ID + "&modal="+item.modal , selected:this.PJ_ID == item.PJ_ID };
                        if(this.PJ_ID == item.PJ_ID){
                            this.type_id = this.PJ_ID.substring(8,this.PJ_ID.length);
                            //加入麵包屑
                            if(this.sider.list.filter(x => x.text == item.etitle).length == 0){
                                this.sider.list.push({text:item.etitle ,url:null});
                            }
                            this.title = item.etitle;
                        }
                        left_list.push(list_item);
                        
                    });
                    this.sideleft.list = left_list;
                }
            }catch(err){
                console.log("ErrFunction: getHeader/n "+err);
            }
        },
        //取得目前文章內容資訊
        async getContent(){
            try{
                //POST參數
                let jsonReq ={
                    TYPE:"GetContent_Front",
                    about_SELECT:{
                        id:this.id,
                        typeId:this.type_id,
                        langurage: this.langurage,
                    }
                };
                //Token
                let resToken = await this.userRequest.post('bicd/Token');
                jsonReq.Token = resToken.data;
                //執行API功能
                let res = await this.userRequest.post("bicd/About",jsonReq);
                //讀取資料
                let json = JSON.parse(res.data);
                if (json.Status){
                    let jsonData = JSON.parse(json.Data);
                    if(jsonData){
                        this.sideright= {
                            title: jsonData.title,
                            onlineDate:"",
                            onlinePlace: "",
                            content:jsonData.description,
                            useTag:false,
                        }
                    }else{
                        this.sideright ={
                            title: this.title,
                            onlineDate:"",
                            onlinePlace: "",
                            content:"Not Data",
                            useTag:false,
                        }
                    }
                }else{
                    this.sideright ={
                        title: this.title,
                        onlineDate:"",
                        onlinePlace: "",
                        content:"Not Data",
                        useTag:false,
                    }
                }
            }catch(err){
                console.log("ErrFunction: getContent/n " + err);
            }
        }
    }
}

</script>